import { useAuthContext } from "@/features/auth/hooks/use-auth-context";
import { Ionicons } from "@expo/vector-icons";
import { Link, Stack } from "expo-router";
import { Text, View } from "react-native";
import { useCSSVariable } from "uniwind";

export default function NotFoundScreen() {
  const { isLoggedIn } = useAuthContext();
  const mutedForeground = useCSSVariable("--color-muted-foreground") as string;
  const href = isLoggedIn ? "/(tabs)" : "/(auth)";
  const label = isLoggedIn ? "Ir para eventos" : "Fazer login";

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <View className="bg-background flex-1 items-center justify-center gap-4 p-8">
        <Ionicons
          name="alert-circle-outline"
          size={64}
          color={mutedForeground}
        />
        <Text className="text-foreground text-center text-2xl font-bold">
          Página não encontrada
        </Text>
        <Text className="text-muted-foreground text-center text-base">
          O conteúdo que você está procurando não existe ou foi removido.
        </Text>
        <Link href={href} replace>
          <View className="bg-brand mt-4 rounded-full px-6 py-3">
            <Text className="text-brand-foreground text-base font-semibold">
              {label}
            </Text>
          </View>
        </Link>
      </View>
    </>
  );
}
